interface GameControlsProps {
  gameOver: boolean;
  onPlayAgain: () => void;
  onReset: () => void;
}

export function GameControls({ gameOver, onPlayAgain, onReset }: GameControlsProps) {
  return (
    <div
      className="flex flex-col items-center gap-3"
      style={{ animation: "fadeIn 0.4s ease-out 0.1s both" }}
    >
      {gameOver && (
        <button
          onClick={onPlayAgain}
          className="
            px-8 py-3 rounded-xl text-base sm:text-lg font-bold
            tracking-wide uppercase
            transition-all duration-200
            hover:scale-105 active:scale-95
            cursor-pointer
          "
          style={{
            fontFamily: "var(--font-display)",
            backgroundColor: "var(--game-surface-hover)",
            color: "var(--game-text)",
            border: "1px solid var(--game-border)",
            boxShadow: "0 0 30px -10px rgba(56,189,248,0.15), 0 0 30px -10px rgba(251,113,133,0.15)",
            animation: "slideUp 0.3s ease-out",
          }}
        >
          Play Again
        </button>
      )}
      <button
        onClick={onReset}
        className="
          px-4 py-1.5 rounded-lg text-xs sm:text-sm
          tracking-widest uppercase
          transition-all duration-200
          hover:opacity-80 active:scale-95
          cursor-pointer
        "
        style={{
          fontFamily: "var(--font-display)",
          color: "var(--game-text-dim)",
          backgroundColor: "transparent",
          border: "none",
        }}
      >
        Reset All
      </button>
    </div>
  );
}
